<template>

    <div class="qtype-3 dd-m-card dd-m-card--quiz-question" :id="'dd-question-' + item.id">
        <h2 class="dd-m-card--quiz-question__title">
            {{item.text}}

            <div class="dd-m-alert dd-m-alert--danger" v-if="hasError">
                <p>Answer all questions to complete the quiz</p>
            </div>
        </h2>

        <ul class="dd-m-card--quiz-question__answers dd-m-card--quiz-question__answers--type-3">
            <li class="dd-m-card--quiz-question__item"
                v-for="(answer, index) in item.answers"
                :key="index"
                v-bind:style="{'backgroundImage' : answer.image ? 'url('+answer.image.mobile+')' : ''}"
                v-bind:class="{ 'is-selected': selected == answer.id }">

                <input v-model="selected"
                       :name="'answer' + item.type + item.position"
                       type="radio"
                       @change="updateAnswer(answer.id)"
                       :value="answer.id"
                       class="dd-m-card--quiz-question__input"/>

                <span class="dd-m-card--quiz-question__select">
                    <i class="dd-m-icon dd-m-icon--default"></i>
                    <i class="dd-m-icon icon-success"></i>
                </span>
            </li>
        </ul>
    </div>

</template>
<script>
    import ScrollService from "../../providers/scroll";

    const scrollService = new ScrollService();

    export default {
        name: 'card-question-type-3',
        props: ['item', 'offline'],
        data: () => {
            return {
                selected: '',
                results: [],
                oldValue: null,
                hasError: false
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('showError', (msg, param) => {
                    if (this.item.id === param) {
                        this.hasError = true;

                        if (this.offline) {
                            scrollService.doSmoothScrollToFromModal(this.item.offset, 20);
                        } else {
                            scrollService.doSmoothScrollTo(`#dd-question-${this.item.id}`, 138);
                        }
                    }
                });
            },
            updateValue(value) {
                PubSub.publish('updateAnswers', value);
                PubSub.publish('updateQuestionsAnswered', {value: this.item.id, remove: false});
                PubSub.publish('goToNextQuestion', this.item.id);
                this.oldValue = value;
            },
            updateAnswer(value) {
                this.hasError = false;
                if (this.oldValue) {
                    PubSub.publish('updateAnswers', this.oldValue);

                    setTimeout(() => this.updateValue(value), 100);
                } else {
                    this.updateValue(value);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/card-question-type-3.vue